import { useLingui } from '@lingui/react/macro'

import { useBrandName } from '@jotta/grpc-connect-client/config'

import { CreateUser } from './CreateUser'
import { SignupContainer } from './SignupContainer'

export function BusinessSignup({
  customerGroupOverride,
}: {
  customerGroupOverride?: string
}) {
  const { t } = useLingui()
  const brandName = useBrandName()
  return (
    <SignupContainer title={t`Try ${brandName} for business free of charge`}>
      <CreateUser
        type="business"
        customerGroupOverride={customerGroupOverride}
        allowAppPromotion={false}
      />
    </SignupContainer>
  )
}
